// components/document-settings/BrandingTab.jsx
// Configurazione branding PDF documenti

import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Save, Palette } from 'lucide-react';

export const BrandingTab = ({
  branding,
  setBranding,
  loading,
  onSaveBranding
}) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <div>
          <h3 className="text-lg font-semibold">Branding PDF</h3>
          <p className="text-sm text-gray-500">Configura l'aspetto dei documenti generati</p>
        </div>
        <Button onClick={onSaveBranding} disabled={loading} className="bg-[#FF7819] hover:bg-[#E56A10]">
          <Save className="w-4 h-4 mr-1.5" />
          Salva
        </Button>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Dati Azienda</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label>Ragione Sociale</Label>
              <Input
                value={branding.company_name}
                onChange={e => setBranding({...branding, company_name: e.target.value})}
              />
            </div>
            <div>
              <Label>Indirizzo Sede Legale</Label>
              <Input
                value={branding.company_address}
                onChange={e => setBranding({...branding, company_address: e.target.value})}
              />
            </div>
            <div>
              <Label>Partita IVA</Label>
              <Input
                value={branding.vat_number}
                onChange={e => setBranding({...branding, vat_number: e.target.value})}
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Email</Label>
                <Input
                  value={branding.email}
                  onChange={e => setBranding({...branding, email: e.target.value})}
                />
              </div>
              <div>
                <Label>Telefono</Label>
                <Input
                  value={branding.phone}
                  onChange={e => setBranding({...branding, phone: e.target.value})}
                />
              </div>
            </div>
            <div>
              <Label>Sito Web</Label>
              <Input
                value={branding.website}
                onChange={e => setBranding({...branding, website: e.target.value})}
              />
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="text-base">Stile Grafico</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Colore Primario</Label>
                <div className="flex gap-2 mt-1">
                  <input
                    type="color"
                    value={branding.primary_color}
                    onChange={e => setBranding({...branding, primary_color: e.target.value})}
                    className="h-10 w-14 rounded border cursor-pointer"
                  />
                  <Input
                    value={branding.primary_color}
                    onChange={e => setBranding({...branding, primary_color: e.target.value})}
                    className="flex-1"
                  />
                </div>
              </div>
              <div>
                <Label>Colore Secondario</Label>
                <div className="flex gap-2 mt-1">
                  <input
                    type="color"
                    value={branding.secondary_color}
                    onChange={e => setBranding({...branding, secondary_color: e.target.value})}
                    className="h-10 w-14 rounded border cursor-pointer"
                  />
                  <Input
                    value={branding.secondary_color}
                    onChange={e => setBranding({...branding, secondary_color: e.target.value})}
                    className="flex-1"
                  />
                </div>
              </div>
            </div>
            <div>
              <Label>Font Famiglia</Label>
              <Select 
                value={branding.font_family}
                onValueChange={v => setBranding({...branding, font_family: v})}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Helvetica">Helvetica</SelectItem>
                  <SelectItem value="Arial">Arial</SelectItem>
                  <SelectItem value="Times New Roman">Times New Roman</SelectItem>
                  <SelectItem value="Georgia">Georgia</SelectItem>
                  <SelectItem value="Verdana">Verdana</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label>Testo Footer Personalizzato</Label>
              <Textarea
                value={branding.footer_text}
                onChange={e => setBranding({...branding, footer_text: e.target.value})}
                placeholder="Testo aggiuntivo da mostrare nel footer dei documenti..."
                rows={3}
              />
            </div>

            {/* Preview */}
            <div className="mt-4 p-4 border rounded-lg">
              <p className="text-sm font-medium mb-2">Anteprima Colori</p>
              <div className="flex gap-2">
                <div 
                  className="w-20 h-10 rounded flex items-center justify-center text-white text-sm font-medium"
                  style={{ backgroundColor: branding.primary_color }}
                >
                  Primario
                </div>
                <div 
                  className="w-20 h-10 rounded flex items-center justify-center text-white text-sm font-medium"
                  style={{ backgroundColor: branding.secondary_color }}
                >
                  Secondario
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default BrandingTab;
